import { config } from "../helpers/domain-config";

export const isMobioVr = config.productName === "mobiovr" ? true : false;
export const isXRZONE = config.productName === "xr-zone" ? true : false;
export const isAFRIVERSE = config.productName === "afri-verse" ? true : false;